// AI Generated Component
import { NgModule, Injectable } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

import { LabelsComponent } from './labels.component';

@Injectable({ providedIn: 'root' })
export class LabelsAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('labels')) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.dashboard', params) as unknown as Promise<void>;
        });
    }
}

/**
 * Labels routing configuration for Angular.
 * This module provides routing for the Labels section with proper access control.
 * Uses Angular service-based access guard following the established pattern.
 */

const labelsStates = [
    // Access-controlled abstract route
    {
        name: 'base.customer.admin_old.labels',
        url: '/labels',
        abstract: true,
        data: {
            featureName: 'labels',
            redirectURI: 'base.dashboard',
            title: 'Acquia Web Governance - Labels',
            htmlContent: '<div ui-view></div>',
        },
        resolve: [
            {
                token: 'labelsAccess',
                deps: [LabelsAccessGuard, Transition],
                resolveFn: (guard: LabelsAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
    },

    // Child route with component
    {
        name: 'base.customer.admin_old.labels.index',
        url: '',
        views: {
            'content@base.customer.admin_old': {
                component: LabelsComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Labels',
            htmlContent: '<div ui-view></div>',
        },
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states: labelsStates })],
    exports: [UIRouterModule],
})
export class LabelsRoutingModule { }
